import { MapContainer, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import NumberMarker from "./NumberMarker";
import { useSelector } from "react-redux";

// Fix for the map not rendring properly
const ComponentResize = () => {
  // Created ResizeComponent , then put inside MapCo ntainer
  const map = useMap();

  setTimeout(() => {
    map.invalidateSize();
  }, 0);

  return null;
};

const Map = ({ center, listing, experiences, car }) => {
  const bookingState = useSelector((state) => state.booking);

  const currentHoverID = bookingState.currentHoverID;

  return (
    <MapContainer
      style={{ height: "100vh" }}
      center={center}
      zoom={16}
      scrollWheelZoom={true}>
      <ComponentResize />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors '
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {listing?.map((item) => (
        <NumberMarker
          key={item.id}
          position={[item.map.lat, item.map.lng]}
          number={item?.price}
          isHovered={item.id === currentHoverID}
          isSelected={currentHoverID === item.id}
          listing={item}
          id={item?.id}></NumberMarker>
      ))}
      {experiences?.map((item) => (
        <NumberMarker
          key={item.id}
          position={[item.map.lat, item.map.lng]}
          number={item?.price}
          isHovered={item.id === currentHoverID}
          isSelected={currentHoverID === item.id}
          experiences={item}
          id={item?.id}></NumberMarker>
      ))}
      {car?.map((item) => (
        <NumberMarker
          key={item.id}
          position={[item.map.lat, item.map.lng]}
          number={item?.price}
          isHovered={item.id === currentHoverID}
          isSelected={currentHoverID === item.id}
          car={item}
          id={item?.id}></NumberMarker>
      ))}
    </MapContainer>
  );
};

export default Map;
